module.exports = __webpack_public_path__ + "img/prioritas_sameday_dg_k.57202d2e.png";